import { IDog, IProfile, MessageTemplating } from '@jumpstart/core';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Grid, { GridProps } from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import { InputProps as MatInputProps } from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import React, { ReactNode, useState } from 'react';
import ContentBaseField from './ContentBaseField';
import KeywordInjector from './KeywordInjector';
import { IValidation, testDog, testDog2, testDog3, testProfile, testProfile2, testProfile3 } from './utils';


interface IOption {
  dog: IDog;
  profile: IProfile;
  id: string
}

const options: IOption[] = [
  {
    dog: testDog,
    profile: testProfile,
    id: 'M'
  },
  {
    dog: testDog2,
    profile: testProfile2,
    id: 'F'
  },
  {
    dog: testDog3,
    profile: testProfile3,
    id: 'N'
  }
];

export type IContentFieldInputProps = Omit<MatInputProps, 'endAdornment'> & {
  additionalEndAdornments?: ReactNode;
};

export interface IContentField {
  id: string;
  name: string;
  touched: boolean;
  validation: IValidation;
  InputProps?: IContentFieldInputProps;
  GridProps?: GridProps;
}

export default function ContentField(props: IContentField & TextFieldProps) {
  const { InputProps, GridProps, validation, touched } = { InputProps: {} as IContentFieldInputProps, GridProps: {}, ...props };
  const [selected, setSelected] = useState<IOption>(options[0]);
  const [example, setExample] = useState(MessageTemplating.process(
    typeof props.value === 'string' ? props.value as string : (typeof props.defaultValue === 'string' ? props.defaultValue as string : ''),
    options[0].dog,
    options[0].profile
  ));
  const [show, setShow] = useState(false);
  const [cache, setCache] = useState(typeof props.value === 'string' ? props.value as string : (typeof props.defaultValue === 'string' ? props.defaultValue as string : ''));

  const generateExample = (value: string) => {
    setExample(MessageTemplating.process(value, selected.dog, selected.profile));
    setCache(value);
  };

  const handleSelect = (option: IOption) => {
    setSelected(option);
    setExample(MessageTemplating.process(cache, option.dog, option.profile));
  };

  return (
    <Grid container direction="column" wrap="nowrap" {...GridProps}>
      <ContentBaseField
        {...props}
        onBlur={(event) => {
          if (props.onBlur) {
            props.onBlur(event);
          }
          generateExample(event.target.value);
        }}
        // onChange={(event) => {
        //   if (props.onChange) {
        //     props.onChange(event);
        //   }
        //   if (show) {
        //     generateExample(event.target.value);
        //   }
        // }}
        // helperText={
        //   <Grid container direction="row" wrap="nowrap" justifyContent="space-between" className={classes.container}>
        //     <Grid item container direction="column">
        //       <Typography variant="caption" color="textPrimary">Render Example: "{example}"</Typography>
        //       {props.helperText}
        //     </Grid>
        //     <Grid item>
        //     <Grid container direction="row" wrap="nowrap" justifyContent="flex-end" className={classes.btnContainer}>
        //       {options.map((option: IOption) => <Button
        //         style={{
        //           backgroundColor: option.id === selected.id ? '#f1f8ff' : '#FAFAFA',
        //           fontWeight: option.id === selected.id ? 600 : 300
        //         }}
        //         className={classes.btn}
        //         key={option.id}
        //         onClick={() => handleSelect(option)}
        //       >
        //         {option.id}
        //       </Button>
        //       )}
        //     </Grid>
        //     </Grid>
        //   </Grid>
        // }
        InputProps={{
          ...InputProps,
          endAdornment: (
            <InputAdornment position="end">
              <KeywordInjector inputId="answer"/>
              <IconButton style={{opacity: 0.7}} size="small" onClick={() => setShow(!show)}>
                {show ? <VisibilityIcon/> : <VisibilityOffIcon/>}
              </IconButton>
              {InputProps.additionalEndAdornments ? InputProps.additionalEndAdornments : null}
            </InputAdornment>
          )
        }}
      />
      <Collapse in={show}>
        <Grid container direction="row" wrap="nowrap" justifyContent="space-between"
              sx={{
                padding: 6,
                '& > :not(:last-child)': {
                  marginRight: 3
                }
              }}
        >
          <Grid item container direction="column">
            <TextField
              {...props}
              id={(props.id ? props.id : 'unknown') + '-render-example'}
              name={(props.id ? props.id : 'unknown') + '-render-example'}
              value={example}
              label={(props.label ? props.label + ' ' : '') + '(Example)'}
              onBlur={() => {
                // do nothing
              }}
              onChange={() => {
                // do nothing
              }}
              helperText="Not part of form, for grammar checking"
              InputProps={{
                ...InputProps,
                endAdornment: (
                  <InputAdornment position="end">
                    <Grid container direction="row" wrap="nowrap" justifyContent="flex-end"
                          sx={{
                            '& > :not(:last-child)': {
                              marginRight: 8
                            }
                          }}
                    >
                      {options.map((option: IOption) => <Button
                          style={{
                            backgroundColor: option.id === selected.id ? '#dae8fc' : '#FAFAFA',
                            fontWeight: option.id === selected.id ? 600 : 300
                          }}
                          sx={{
                            borderRadius: '4px',
                            fontSize: 14,
                            width: 20,
                            minWidth: 20,
                            height: 20,
                            color: 'rgba(0,0,0,0.7)'
                          }}
                          key={option.id}
                          onClick={() => handleSelect(option)}
                        >
                          {option.id}
                        </Button>
                      )}
                    </Grid>
                  </InputAdornment>
                )
              }}
            />
          </Grid>
        </Grid>
      </Collapse>
    </Grid>
  );
}
